// import { useCart } from '../hooks/useCart';
// import { Merch } from '../components/Merch';
// import CallOutForm from '../forms/CallOutForm';
// import useRenderCounter from '../services/checkRender';
// import { SupportArtistForm } from '../forms/SupportArtistForm';
// import { DirectMessage } from '../components/DirectMessage';

import { toast } from 'react-hot-toast';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Calendar } from '../components/Calendar/CalandarBody';
import { fetchProfileById, followUser } from '../services/fetch-utils';

import '../css/PublicProfile.css';

import { Tabs } from '../components/Tabs';
import { useUser } from '../hooks/useUser';
import { MySongs } from '../components/Songs/MySongs';
import { MyVideos } from '../components/Videos/MyVideos';
import { UserProfile } from '../interfaces/userInterfaces';
import { DirectMessageUser } from '../components/Messages/MessageViews/DirectMessageUser';

export function PublicProfile() {
  //   const { addToCart } = useCart();
  const [profile, setProfile] = useState<UserProfile>({} as UserProfile);
  const [publicPage, setPublicPage] = useState<boolean>(true);
  const { id } = useParams();
  const { user, isUserProfile } = useUser();

  useEffect(() => {
    const getAndSet = async () => {
      const userProfile = await fetchProfileById(id!);
      if (userProfile.status === 200 && isUserProfile(userProfile.data)) {
        !userProfile.data.avatar_url &&
          (userProfile.data.avatar_url =
            'https://nqbvdgzoxvmdlnjovyqu.supabase.in/storage/v1/object/public/avatars/default-avatar/userexpression.png');
        setProfile(userProfile.data);
      }
    };
    getAndSet();
  }, [id, isUserProfile]);

  useEffect(() => {
    if (profile.username === user?.username) setPublicPage(false);
  }, [profile, user]);

  //   useEffect(() => {
  //     const idArray = [
  //       'modal-form',
  //       'show-modal-button',
  //       'support-artist-form',
  //       'support-artist-amount',
  //       'support-artist-form-label',
  //       'send-artist-support-button',
  //       'support-artist-form-header',
  //       'support-artist-form-container',
  //     ];

  //         const closeModalWindow = (e) => {
  //           if (!idArray.includes(e.target.id)) {
  //             setShowModal(false);
  //           }
  //         };

  //         window.addEventListener('click', (e) => closeModalWindow(e));
  //       }, [showModal]);
  //   }, [showModal]);

  const handleFollow = async () => {
    const followObj = {
      follower: user?.user_id,
      follower_username: user?.username,
      followed: profile?.user_id,
      followed_username: profile?.username,
      unique_follow_code: `${profile?.user_id}-${user?.user_id}`,
    };
    const followRequest = followUser(followObj);
    toast.promise(followRequest, {
      loading: 'Adding User to List of Follows',
      success: `Successfully added ${profile.username} to list of follows`,
      error: 'Oops! Something went wrong. Please try again.',
    });
  };

  const publicProfile = {
    tabs: ['Videos', 'Songs', 'Calendar', `DM ${profile.username}`],
    // tabs: ['Videos', 'Songs', 'Calendar', 'Message', 'CallOut', 'Merch'],
    content: [
      <MyVideos key={'user-vids'} profile={profile} />,
      <MySongs key={'user-songs'} profile={profile} />,
      <Calendar key={'public-calendar'} useCase={'public'} profile={profile} />,
      <DirectMessageUser key={'DM-User'} profile={profile.username} />,
      //   <DirectMessage key={'dm'} profile={profile?.username} />,
      //   <CallOutForm key={'call-out-form'} opponent={profile} />,
      //   <Merch key={'merchandise'} productList={profile?.merch} />,
    ],
    modal: false,
  };
  return (
    <div className="public-profile-container">
      <div>
        <span id="public-profile-name-avatar-container">
          <img className="public-avatar" src={profile?.avatar_url} alt="Profile Pic"></img>
          <p className="public-username">{profile.username}</p>
        </span>
        <button onClick={handleFollow} className="public-follow-button">
          Follow {profile.username}
        </button>
        {/* <button
            id="show-modal-button"
            onClick={() => setShowModal(!showModal)}
            className="public-follow-button"
          >{`Support ${profile.username} with a donation`}</button>
          <span
            id="modal-form"
            className={showModal ? 'support-artist-form show-form' : 'support-artist-form'}
          >
            <SupportArtistForm profile={profile} />
          </span> */}
        <Tabs page={publicProfile} />
      </div>
    </div>
  );
}
